import { render, staticRenderFns } from "./DisconnectConfirmDialog.vue?vue&type=template&id=c804fde0&scoped=true&"
import script from "./DisconnectConfirmDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DisconnectConfirmDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DisconnectConfirmDialog.vue?vue&type=style&index=0&id=c804fde0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c804fde0",
  null
  
)

export default component.exports